import React from 'react'
import { IoSearchOutline } from 'react-icons/io5'

const SearchBar = ({ searchTerm, setSearchTerm,placeholder }) => {
  return (
    <div className='relative lg:w-72 w-full'>
      <div className='absolute inset-y-0 left-0 flex items-center pl-3'>
        <IoSearchOutline size={20} className='text-black' />
      </div>
      <input
        type='text'
        id='simple-search'
        className='w-full pl-10 px-4 py-2 bg-[#FFFFFF] border border-[#E0E2E7] text-black rounded-lg placeholder:text-[#858D9D]'
        placeholder={placeholder?placeholder:"Search here.."}
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
      />
    </div>
  )
}

export default SearchBar
